module.exports = __webpack_public_path__ + "img/home-btn-guide.80313b2f.svg";